import React from 'react';
import { Route, Switch } from 'react-router-dom';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import FormAddCar from './FormAddCarPartner';
import FormAddMotorbike from './FormAddMotorbikePartner';
import ListVehiclePartner from './ListVehiclePartner';
import MyUtil from '../../functions/MyUtil';

const VehiclePartner = (props) => {
  const { match } = props;
  return (
    <Switch>
      {MyUtil.hasPermission(match.url, 'view') && (
        <Route
          exact
          path={`${match.url}`}
          component={() => <ListVehiclePartner match_parent={match} />}
        />
      )}
      {MyUtil.hasPermission(match.url, 'add') && (
        <Route path={`${match.url}/add-car-partner`} component={FormAddCar} />
      )}
      {MyUtil.hasPermission(match.url, 'update') && (
        <Route path={`${match.url}/edit-car-vehicle-partner/:vhc_part_id`}>
          <FormAddCar />
        </Route>
      )}
      {MyUtil.hasPermission(match.url, 'update') && (
        <Route path={`${match.url}/edit-moto-vehicle-partner/:vhc_part_id`}>
          <FormAddMotorbike />
        </Route>
      )}
      {MyUtil.hasPermission(match.url, 'add') && (
        <Route
          path={`${match.url}/add-motorbike-partner`}
          component={FormAddMotorbike}
        />
      )}
    </Switch>
  );
};

export default VehiclePartner;
